import React, { useEffect, useState } from "react";
import topFlowerImg from "../../assets/images/svg/top_flower.svg";
import bottomFlowerImg from "../../assets/images/svg/bottom_flower.svg";
import greatSoulImg from "../../assets/images/the-great-souls/png/temple_the_great_souls.png";
import greatDecorate from "../../assets/images/coursesPage/LordGaveBapu/png/bapuBgDecorate.png";
import orangeTick from "../../assets/images/svg/orenge_tick.svg";
import Button from "../common/button/Button";
import CommonHeading from "../common/heading/CommonHeading";
import { ModalList } from "../../utils/TheGreateSageHelper";
import Modal from "../common/modal/Modal";
import { greateSageList } from "../../utils/TheGreateSageHelper";
const TheGreatSage = () => {
  const [popupOpen, setPopupOpen] = useState(null);

  function showPopup(index) {
    setPopupOpen(popupOpen === index ? null : index);
  }

  const isModalOpen = popupOpen !== null;
  useEffect(() => {
    if (isModalOpen) {
      document.getElementById("html").classList.add("overflow-hidden");
    } else {
      document.getElementById("html").classList.remove("overflow-hidden");
    }

    // Cleanup on component unmount
    return () => {
      document.getElementById("html").classList.remove("overflow-hidden");
    };
  }, [isModalOpen]);
  return (
    <>
      <div className="position-relative great_souls pt-2">
        {/*<img
          className="position-absolute bottom_flower_mahamantra end-0 maharaj_top z_index_n2"
          src={bottomFlowerImg}
          alt="bottom_flower"
        />*/} 
        <img
          src={greatSoulImg}
          className="w-25 position-absolute start-0"
          style={{ bottom: "-10%" }}
          alt="temple_the_great_souls"
        />
        <img
          src={greatDecorate}
          className="bapuBgDecorate position-absolute start-0 d-none d-sm-block"
          alt="bapuBgDecorate"
        />
        <img
          src={greatDecorate}
          className="bapuBgDecorate position-absolute end-0 d-none d-sm-block"
          alt="bapuBgDecorate"
        />
        {/*<img
          className="position-absolute top_flower_mahamantra souls_top_flower start-0 the_great_flower"
          src={topFlowerImg}
          alt="top_flower"
        />*/}

        <div className="container_modified container position-relative mt-0 pt-3 pt-sm-4">
          <div className="row justify-content-center mt-xl-2">
            <div className="col-lg-11 text-center mb-4 pb-lg-2">
              <CommonHeading
                heading="Trimurti Ashram"
                className="text-orange common_heading_text common_heading_text_brown"
              />
              <h2 className="common_sub_heading text-center mb-1 mb-md-3 px-4 px-md-0">
                Giving to you what the Lord Gave{" "}
                <br className="d-none d-md-inline" />
                to the Great Sage
              </h2>
            </div>
          </div>
          <div className="row justify-content-between mb-3 pb-3">
            <div className="col-lg-7">
              <div className="d-flex gap-2 mb-md-3 mb-2">
                <img src={orangeTick} className="mb-auto mt-1" alt="tick" />
                <p className="common_para lh_25 mb-0 pe-xl-5">
                  In order to receive, enjoy and integrate the Divine gift that
                  Bapu won on your behalf, a retreat of ten days has been
                  designed to best do justice to this gift. Each day is planned
                  as an experience of fullness, starting with Yoga asanas,
                  followed by a 1st session of Spontaneous Meditation.
                </p>
              </div>
              <div className="d-flex gap-2 mb-md-3 mb-2">
                <img src={orangeTick} className="mb-auto mt-1" alt="tick" />
                <p className="common_para lh_25 mb-0 pe-xl-4">
                  Intimate course size means personal attention. After
                  breakfast, an eye-opening talk by the Retreat Master invites
                  the 2nd meditation session, with your every question being
                  carefully considered.
                </p>
              </div>
              <div className="d-flex gap-2 mb-md-3 mb-2">
                <img src={orangeTick} className="mb-auto mt-1" alt="tick" />
                <p className="common_para lh_25 mb-0 pe-xl-4">
                  Lunch leads to rest, with afternoon boasting another Yoga
                  asana experience with Dr. Manoj Vats, followed by Satsang and
                  a final meditative deep dive into your inner nature.
                </p>
              </div>
              <div className="d-flex gap-2 mb-md-3 mb-2">
                <img src={orangeTick} className="mb-auto mt-1" alt="tick" />
                <p className="common_para lh_25 mb-0 pe-xl-3">
                  Meals are offered in the vegetarian tradition of Rishikesh.
                  Our Trimurti chef creates delicious Gujarati fare of the
                  highest quality. Dinner is amply served in our dining hall,
                  followed by Satsang in the Temple. You will enjoy sleeping on
                  the banks of the Ganga.
                </p>
              </div>
              <div className="d-flex gap-2 mb-md-3 mb-2">
                <img src={orangeTick} className="mb-auto mt-1" alt="tick" />
                <p className="common_para lh_25 mb-0 pe-sm-5">
                  Two or three outings will spice and expand your 10 days of
                  Yoga Sadhana, and several free time possibilities will keep
                  you feeling at ease while you take in the deepening
                  opportunities of real spiritual experience.
                </p>
              </div>
            </div>
            <div className="col-md-6 col-lg-5 ps-lg-0 mx-auto mt-4 mt-lg-0">
              {greateSageList.map((obj, index) => {
                return (
                  <div
                    className="position-relative z-3 text-center"
                    key={index}
                    onClick={() => showPopup(index)}
                  >
                    <div className="position-absolute w-100 d-flex justify-content-center bottom-0 pb-4 pb-lg-5 mb-3 mb-lg-2">
                      <Button title={obj.title} className="great_sage_btn" />
                    </div>
                    <img
                      src={obj.image}
                      className="w-100 max_sm_w cursor_pointer"
                      alt="sage-bapu-img"
                    />
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      </div>
      {isModalOpen && (
        <div
          className="nav_overlay position-fixed top-0 start-0 vh-100 w-100 z_index_4"
          onClick={() => setPopupOpen(null)}
        ></div>
      )}
      {isModalOpen && (
        <Modal
          data={ModalList[popupOpen]}
          showPopup={() => setPopupOpen(null)}
        />
      )}
    </>
  );
};

export default TheGreatSage;
